export const FORGOT_FAILED_MESSAGE = "재설정 메일을 보내지 못했습니다. 잠시 후 다시 시도하세요.";
